export default "__VITE_ASSET__BEq9wCOa__"